import { typeof as _typeof, toConsumableArray as _toConsumableArray, defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import assign from 'object-assign';
import { get, memoizedGet } from '../utils/object.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
// port from @styled-system/core v.5.1.2

var merge = function merge(a, b) {
  var result = assign({}, a, b);
  for (var key in a) {
    if (!a[key] || _typeof(b[key]) !== 'object') continue;
    assign(result, _defineProperty({}, key, assign(a[key], b[key])));
  }
  return result;
};

// sort object-value responsive styles
var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};
var defaults = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};
var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: ".concat(n, ")");
};
var getValue = function getValue(n, scale) {
  return memoizedGet(scale, n, n);
};
var createParser = function createParser(config) {
  var cache = {};
  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;
    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaults);
      if (_typeof(raw) === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults.breakpoints);
        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(_toConsumableArray(cache.breakpoints.map(createMediaQuery)));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }
        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }
        continue;
      }
      assign(styles, sx(raw, scale, props));
    }

    // sort object-based responsive styles
    if (shouldSort) {
      styles = sort(styles);
    }
    return styles;
  };
  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });
  if (keys.length > 1) {
    keys.forEach(function (key) {
      parse[key] = createParser(_defineProperty({}, key, config[key]));
    });
  }
  return parse;
};
var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);
    if (!media) {
      assign(styles, style);
    } else {
      assign(styles, _defineProperty({}, media, assign({}, styles[media], style)));
    }
  });
  return styles;
};
var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};
  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);
    if (!breakpoint) {
      assign(styles, style);
    } else {
      var media = createMediaQuery(breakpoint);
      assign(styles, _defineProperty({}, media, assign({}, styles[media], style)));
    }
  }
  return styles;
};
var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
    property = _ref.property,
    scale = _ref.scale,
    _ref$transform = _ref.transform,
    transform = _ref$transform === void 0 ? getValue : _ref$transform,
    defaultScale = _ref.defaultScale;
  properties = properties || [property];
  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      if (_typeof(n) === 'object') {
        result = _objectSpread2(_objectSpread2({}, result), n);
      } else {
        result[prop] = n;
      }
    });
    return result;
  };
  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
};

// new v5 API
var system = function system() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];
    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }
    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }
    config[key] = createStyleFunction(conf);
  });
  var parser = createParser(config);
  return parser;
};
var compose = function compose() {
  var config = {};
  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }
  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    assign(config, parser.config);
  });
  var parser = createParser(config);
  return parser;
};

export { compose, createParser, system };
//# sourceMappingURL=system-core.esm.js.map
